import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { take } from 'rxjs/operators';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { FormGroup, FormControl } from '@angular/forms';
import { ManifestoEmbarquePainelService } from 'src/app/services/manifesto-embarque-painel.service';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { PaginacaoComponent } from 'src/app/@shared/components';
import { StorageService } from 'src/app/services/storage/storage.service';

import { MatCheckbox } from '@angular/material/checkbox';
import { ModalConfirmacaoComponent } from '../modal-confirmacao/modal-confirmacao.component';
import { ModalManifestoEmbarqueRessalvaComponent } from 'src/app/@feature/manifesto-embarque/manifesto-embarque/manifesto-embarque-painel/modal-manifesto-embarque-ressalva/modal-manifesto-embarque-ressalva.component';

interface IContador {
  horas: number;
  minutos: number;
  segundos: number;
}

@Component({
  selector: 'app-modal-manifesto-detalhes-embarque',
  templateUrl: './modal-manifesto-detalhes-embarque.component.html',
  styleUrls: ['./modal-manifesto-detalhes-embarque.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class ModalManifestoDetalhesEmbarqueComponent implements OnInit {
  public isLoading = false;
  public manifestosId: any;
  public modalItem: any;
  public pedidoIds: any[];
  public pedidoEtiquetas: any[] = [];
  public pedidoVolumeDetalhamento: any[] = [];
  public title: string = "Detalhes de Pedidos de Manifesto de Transferência";
  public expandedElement: any | null = null;
  public isRessalvaPorVolume: boolean;
  public isShowCheckOnPedido: boolean = true;
  private total: Number = 0;

  @ViewChild(PaginacaoComponent, { static: false }) paginator: PaginacaoComponent;

  public contadorDados: IContador = {
    horas: 0,
    minutos: 0,
    segundos: 0
  };

  public manifestoIdTransferenciaOuDevolucao: number;
  public numeroCompletoManifesto: number;
  public manifestoEmbarqueId: number;
  public isDevolucao: boolean;
  public perfilAcessoTipo;
  public allSelected = false;
  public someSelected = false;

  public contador: string;
  public contSeg: number = 0;
  public contMin: number = 0;

  public displayedColumns: string[] = [
    'checkbox',
    'cliente',
    'segmento',
    'NRT',
    'volumes',
    'documento',
    'destinatario',
    'cidade',
    'UF',
    'dtRecepcao',
    'RAT'
  ];

  public displayedColumnsSubTable: string[] = [
    'checkbox',
    'ressalva',
    'idVolume',
    'etiqueta',
    'etiqueta2',
    'altura',
    'comprimento',
    'largura',
    'peso',
  ];


  public displayedColumnsSubTable2: string[] = [
    'mt',
    'idVolume',
    'etiqueta',
    'etiqueta2',
    'altura',
    'comprimento',
    'largura',
    'peso',
  ];


  public paging = { index: 0, size: 10, length: 0 };
  public collection: MatTableDataSource<any> = new MatTableDataSource<any>();

  public form: FormGroup = new FormGroup({
    cliente: new FormControl(),
    dataRecepcao: new FormControl({ value: '-1', disabled: false }),
    ressalva: new FormControl({ value: '-1', disabled: false }),
    codigoBarras: new FormControl(),
    nrt: new FormControl()
  });

  get codigoBarras() { return this.form.get('codigoBarras').value; }

  @ViewChild('allCheckbox') allCheckbox: MatCheckbox;

  constructor(
    private service: ManifestoEmbarquePainelService,
    private dialogRef: MatDialogRef<ModalManifestoDetalhesEmbarqueComponent>,
    public dialog: MatDialog,
    public router: Router,
    public snackBar: MatSnackBar,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.modalItem = data.item;
    this.manifestoIdTransferenciaOuDevolucao = this.modalItem?.meDetalheItem.manifestoId;
    this.numeroCompletoManifesto = this.modalItem?.meDetalheItem.numeroCompletoManifesto;
    this.manifestoEmbarqueId = this.modalItem?.manifestoEmbarqueId;
    this.isDevolucao = this.modalItem?.isDevolucao;
    this.pedidoIds = []
    this.pedidoEtiquetas = [];
    this.pedidoVolumeDetalhamento = [];
    this.perfilAcessoTipo = StorageService.getPerfilUsuario().perfilacessotipo;
  }

  ngOnInit() {
    this.search();
    this.startContador();
    this.initParameters();

    if (this.isDevolucao) {
      this.title = "Detalhes de Pedidos de Manifesto de Devolução";
    }
  }

  changePedidosIds(pedidoId, item, selected: boolean) {
    if (selected) {

      if (this.isRessalvaPorVolume === true && this.isDevolucao !== true) {
        if (!this.pedidoEtiquetas.find(p => p.pedidoId == pedidoId))
          this.pedidoEtiquetas.push({ pedidoId: pedidoId });

        var object = this.pedidoEtiquetas.find(p => p.pedidoId == pedidoId);
        //object.volumes filha
        if (object) {
          if (object.volumes) {
            object.volumes.push({ pedidoEtiquetaId: item.pedidoEtiquetaId, volumeId: item.volumeId, selected: selected });
            object.selected = selected;
          } else {
            object.volumes = [];
            object.volumes.push({ pedidoEtiquetaId: item.pedidoEtiquetaId, volumeId: item.volumeId, select: selected });
            object.selected = selected;
          }
          this.pedidoEtiquetas.push(object);
        }
      }
      else {
        this.pedidoIds.push(pedidoId);
      }
    } else {

      if (this.isRessalvaPorVolume === true && this.isDevolucao !== true) {

        var object = this.pedidoEtiquetas.find(p => p.pedidoId == pedidoId);
        if (object) {
          var indexOf = object.volumes.findIndex(p => p.pedidoEtiquetaId === item.pedidoEtiquetaId);
          if (indexOf > -1)
            object.volumes.splice(indexOf, 1);

          if (!object.volumes || object.volumes.length === 0) {
            var indexOfPedido = this.pedidoEtiquetas.findIndex(p => p.pedidoId == pedidoId);
            if (indexOfPedido > -1)
              this.pedidoEtiquetas.splice(indexOfPedido, 1);
          }
        }
      }
      else {
        var indexOfPedido = this.pedidoIds.indexOf(pedidoId);
        if (indexOfPedido > -1) {
          this.pedidoIds.splice(indexOfPedido, 1);
        }
      }
    }
  }



  private PegaContador() {
    this.service.getMEDetalheContador({
      manifestoEmbarqueId: this.manifestoEmbarqueId,
      manifestoId: this.numeroCompletoManifesto,
      isDevolucao: this.isDevolucao,
      agenteId: this.modalItem.agenteId
    })
      .pipe(take(1)).subscribe(
        (successResponse: HttpResponse<any>) => {
          let response = successResponse as any;
          if (response) {
            this.contador = response.contador;
            var dados = this.contador.split(':');
            this.contadorDados.horas = parseInt(dados[0]);
            this.contadorDados.minutos = parseInt(dados[1]);
            this.contadorDados.segundos = parseInt(dados[2]);
            this.contSeg = 60 - this.contadorDados.segundos;
          }
          this.isLoading = false;
        },
        (err: HttpErrorResponse) => {
          console.error(err);
          this.isLoading = false;
          this.openSnackBar('Erro ao carregar contador, entre em contato com o suporte : ' + err.error.Protocolo ?? err.error.Message, 'OK', 10000, 'danger-snackbar');
        });
  }

  async startContador() {
    setInterval(() => {

      if (this.contadorDados.horas != 0 || this.contadorDados.minutos != 0 || this.contadorDados.segundos != 0) {
        if (this.contSeg >= 60) {
          if (this.contadorDados.minutos == 0) {
            this.contadorDados.minutos = 59;

            if (this.contadorDados.horas > 0) {
              this.contadorDados.horas--;
            }
            this.contMin = 0;
          } else {
            this.contadorDados.minutos--;
          }
          this.contSeg = 0;
          this.contadorDados.segundos = 59;
          this.contMin++;
        } else {
          this.contadorDados.segundos--;
        }

        this.contSeg++;

        this.contador = `${this.contadorDados.horas.toString()}:${this.contadorDados.minutos.toString().padStart(2, '0')}:${this.contadorDados.segundos.toString().padStart(2, '0')}`;
      }
    }, 1000);
  }

  public search(shouldResetPagination: boolean = true) {

    if (this.codigoBarras && this.codigoBarras != null && ((Number(this.codigoBarras) && Number.parseInt(this.codigoBarras) > 2147483647) || (Number(this.codigoBarras) && !Number.isSafeInteger(Number.parseInt(this.codigoBarras))))) {
      this.openSnackBar('Inteiro maior do que o permitido!', 'OK', 5000, 'warning-snackbar');
      return;
    }

    this.isLoading = true;
    if (shouldResetPagination)
      this.collection.data = null;

    this.resetOrNotPagination(shouldResetPagination);

    this.service.getMEDetalhes({
      manifestoId: this.manifestoIdTransferenciaOuDevolucao,
      isDevolucao: this.isDevolucao,
      dataRecepcao: this.form.controls['dataRecepcao'].value,
      ressalva: this.form.controls['ressalva'].value,
      codigoBarras: this.form.controls['codigoBarras'].value,
      paginaAtual: this.paging.index,
      itensPorPagina: this.paging.size,
    })
      .pipe(take(1)).subscribe(
        (response: HttpResponse<any>) => {
          this.collection.data = null;
          this.collection.data = response.body;
          if (response.body.length > 0) {
            this.paging.length = response.body[0].totalCount;
            if(shouldResetPagination){

              this.total = response.body[0].totalCount;
            }
          }

          if (this.allSelected === true) {
            this.selectAll(this.allSelected, true);
          }

          this.updateSelection();
          this.PegaContador();

          this.isLoading = false;
        },
        (err: HttpErrorResponse) => {
          console.error(err);
          this.isLoading = false;
          this.openSnackBar('Erro ao carregar listagem, entre em contato com o suporte : ' + err.error.Protocolo ?? err.error.Message, 'OK', 10000, 'danger-snackbar');
        });

    if (shouldResetPagination) {

      this.pedidoIds = [];
      this.pedidoEtiquetas = [];
      this.pedidoVolumeDetalhamento = [];
    }
  }

  public clearFields() {
    this.form.reset();
    this.collection = new MatTableDataSource<any>();
    this.form.controls['dataRecepcao'].setValue('-1');
    this.form.controls['ressalva'].setValue('-1');
    this.paging.index = 0;
  }

  public openModalMERessalva(): void {
    let dynamicObject = {};

    if (this.isRessalvaPorVolume === true ) {
      if (this.isDevolucao === true)
        dynamicObject = { pedidoEtiquetas: this.pedidoEtiquetas, manifDevTranspId: this.manifestoIdTransferenciaOuDevolucao }
      else
        dynamicObject = { pedidoEtiquetas: this.pedidoEtiquetas, manifTransfId: this.manifestoIdTransferenciaOuDevolucao }
    }
    else {
      if (this.isDevolucao === true)
        dynamicObject = { pedidoIds: this.pedidoIds, manifDevTranspId: this.manifestoIdTransferenciaOuDevolucao }
      else
        dynamicObject = { pedidoIds: this.pedidoIds, manifTransfId: this.manifestoIdTransferenciaOuDevolucao }
    }

    dynamicObject["isRessalvaPorVolume"] = this.isRessalvaPorVolume;
    dynamicObject["manifestoEmbarqueId"] = this.manifestoEmbarqueId;

    const modalReference = this.dialog.open(ModalManifestoEmbarqueRessalvaComponent, {
      width: '600px',
      data: { item: dynamicObject }
    });

    modalReference.afterClosed().subscribe(() => {
      this.pedidoIds = [];
      this.paging.index = 0;
      this.selectAll(false);
      this.search();
    });
  }

  public backendSearchAndSelectAll() {

    this.service.getMEDetalhes({
      manifestoId: this.manifestoIdTransferenciaOuDevolucao,
      isDevolucao: this.isDevolucao,
      dataRecepcao: this.form.controls['dataRecepcao'].value,
      ressalva: this.form.controls['ressalva'].value,
      nrt: this.form.controls['nrt'].value,
      paginaAtual: 0,
      itensPorPagina: 99999999,
    })
      .pipe(take(1)).subscribe(
        (response) => {
          response.body.forEach(item => {
            if (!(item.rat && item.rat > 0) && item.flgEmRota === false) {
              if (!this.pedidoIds.includes(item.nrt))
                this.pedidoIds.push(item.nrt);
            }
          });

          this.updateSelection();
        },
        (err: HttpErrorResponse) => {
          console.error(err);
          this.openSnackBar('Erro ao carregar listagem, entre em contato com o suporte : ' + err.error.Protocolo ?? err.error.Message, 'OK', 10000, 'danger-snackbar');
        });
  }



  public backendSearchAndSelectAllItem(selected) {
    this.service.getMEDetalhes({
      manifestoId: this.manifestoIdTransferenciaOuDevolucao,
      isDevolucao: this.isDevolucao,
      dataRecepcao: this.form.controls['dataRecepcao'].value,
      ressalva: this.form.controls['ressalva'].value,
      nrt: this.form.controls['nrt'].value,
      paginaAtual: 0,
      itensPorPagina: 99999999,
    })
      .pipe(take(1)).subscribe(
        (response) => {
          this.isLoading = true;
          this.setTotalItens(response.body);
          this.saveOnMemoryVolumeMultiple(response.body, selected);


          this.updateSelection();
          this.isLoading = false;
        },
        (err: HttpErrorResponse) => {
          console.error(err);
          this.openSnackBar('Erro ao carregar listagem, entre em contato com o suporte : ' + err.error.Protocolo ?? err.error.Message, 'OK', 10000, 'danger-snackbar');
          this.isLoading = false;
        });
  }

  public select(item, selected: boolean) {
    this.pedidoIds = [];
    if (selected) {
      this.pedidoIds.push(item.nrt);
    } else {
      var indexOf = this.pedidoIds.indexOf(item.nrt);
      if (indexOf > -1) {
        this.pedidoIds.splice(indexOf, 1);
        this.allSelected = false;
      }
    }

    this.updateSelection();
  }


  selectAll(selected: boolean, pageChange: boolean = false) {
    if (pageChange === false && this.allSelected === false && selected === true) {
      const dialogRef = this.dialog.open(ModalConfirmacaoComponent, {
        width: '540px',
        data: {
          textoCancelar: "Não",
          textoOk: "Sim",
          texto: this.isRessalvaPorVolume === false ? "Tem certeza de que deseja selecionar todos os pedidos?" : "Tem certeza de que deseja selecionar todos volumes de todos os pedidos?",
        },
      });

      dialogRef.afterClosed().pipe(take(1)).subscribe(
        async response => {
          if (response === 1) {
            this.isLoading = true;
            this.allSelected = selected;
            this.pedidoIds = [];
            this.pedidoEtiquetas = [];
            this.pedidoVolumeDetalhamento = [];
            if (this.collection.data && this.collection.data.length)
              if (this.isRessalvaPorVolume == true) {
                this.backendSearchAndSelectAllItem(selected);
              } else {
                this.backendSearchAndSelectAll();
              }
          }
          else {
            this.allSelected = false;
            this.allCheckbox.checked = false;
          }

        });

    }
    else {
      this.allSelected = selected;
      if (this.allSelected === false)
        if (this.collection.data && this.collection.data.length) {
          this.pedidoIds = [];
          this.pedidoEtiquetas = [];
          this.pedidoVolumeDetalhamento = [];
          {
            this.collection.data.forEach(i => {
              i.selected = selected;
            });
          }
        }
      this.updateSelection();
    }
  }


  selectAllItem(selected: boolean, pedido: object, pageChange: boolean = false) {

    if (pageChange === false && this.allSelected === false && selected === true) {
      const dialogRef = this.dialog.open(ModalConfirmacaoComponent, {
        width: '540px',
        data: {
          textoCancelar: "Não",
          textoOk: "Sim",
          texto: "Tem certeza de que deseja selecionar todos os volumes?",
        },
      });

      dialogRef.afterClosed().pipe(take(1)).subscribe(
        async response => {
          if (response === 1) {
            this.saveOnMemoryVolume(pedido, selected);
          }
          else {

            this.allSelected = false;
            this.allCheckbox.checked = false;
          }
          this.updateSelection();
        });
    }
    else {

      this.allSelected = selected;
      if (this.allSelected === false)
        if (this.collection.data && this.collection.data.length) {
          pedido["selected"] = selected;
          this.saveOnMemoryVolume(pedido, selected);

          this.updateSelection();
        }
    }
  }

  updateSelection() {
    if (this.isRessalvaPorVolume === false) {
      let total = 0;
      let selecteds = 0;

      if (this.collection.data && this.collection.data.length) {
        total = this.collection.data.filter(item => !(item.rat && item.rat > 0) && item.flgEmRota === false).length;
        selecteds = this.pedidoIds.length;
        this.collection.data.forEach(p => {
          if (this.pedidoIds.includes(p.nrt)) p.selected = true;
          else p.selected = false;
        });


      }

      if (selecteds === 0) {
        this.allSelected = false;
        this.someSelected = false;
      } else if (selecteds < total) {
        this.allSelected = false;
        this.someSelected = true;
      } else {
        this.allSelected = true;
        this.someSelected = false;
      }

    } else {

      var selecteds = 0;

      if (this.collection.data && this.collection.data.length) {

        let pedidoVolumeDetalhamento = this.pedidoVolumeDetalhamento;
        selecteds = this.pedidoVolumeDetalhamento.length;
        this.collection.data.forEach(p => {

          //pega o total de volumes dos pedido
          let totalVolumesPedido = p["pedidoVolumeDetalhamento"].filter(volume => volume.temRessalva !== "Sim").length;
          let volumePedidoSelected = 0;


          p["pedidoVolumeDetalhamento"]
          .filter(volume => volume.temRessalva !== "Sim")
          .forEach(element => {
            if (pedidoVolumeDetalhamento.find(v => v["volumeId"] == element["volumeId"])) {
              element["selected"] = true;
              volumePedidoSelected++;
            } else {
              element["selected"] = false;
            }
          });

          if (totalVolumesPedido != 0 && totalVolumesPedido == volumePedidoSelected) {
            p["selected"] = true;
            p["someSelected"] = false;
          } else if(volumePedidoSelected != 0 && volumePedidoSelected < totalVolumesPedido) {
            p["selected"] = false;
            p["someSelected"] = true;

          } else {
            p["selected"] = false;
            p["someSelected"] = false;
          }
        });


      }
      if (selecteds === 0) {
        this.allSelected = false;
        this.someSelected = false;
      } else if (selecteds < Number(this.total)) {
        this.allSelected = false;
        this.someSelected = true;
      } else {
        this.allSelected = true;
        this.someSelected = false;
      }
    }
  }

  public goRessalva() {
    this.router.navigate(['transferencias/manifesto-embarque/ressalvas/tipos-ressalvas']);
  }

  public voltar() {
    this.dialogRef.close();
  }

  public onPageChange(evt: { pageIndex: number; pageSize: number }) {

    this.paging.index = evt.pageIndex;
    this.paging.size = evt.pageSize;
    this.search(false);
  }

  private resetOrNotPagination(shouldResetPagination: boolean) {
    if (shouldResetPagination === true) {
      this.paging.index = 0;
      if (this.paginator)
        this.paginator.goTo = 1;
    }
  }

  private initParameters() {
    console.log(this.modalItem.agenteId);
    this.isLoading = true;
    this.service.getMEParametro({
      chave: 'RESSALVA_POR_VOLUME',
      agenteId: this.modalItem.agenteId
    })
      .pipe(take(1))
      .subscribe((response: HttpResponse<any[]>) => {

        this.isRessalvaPorVolume = (<any>response.body).valor === '1';
        this.ShowColumnsOrNot();
        this.isLoading = false;
      }, () => {
        this.isLoading = false;
        this.openSnackBar('Erro ao carregar a parametrização!', 'OK', 5000, 'danger-snackbar');
      });
  }

  private ShowColumnsOrNot() {
    if (this.isRessalvaPorVolume === true) {
      this.isShowCheckOnPedido = false;
    }

  }


  private openSnackBar(message: string, action: string, duration: number, panelClass?: string): any {
    this.snackBar.open(message, action, { duration, panelClass });
  }

  saveOnMemoryVolume(pedido, selected) {
    if (pedido.flgEmRota === false) {
      var pedidoId = parseInt(pedido["nrt"]);
     var volumes =  pedido["pedidoVolumeDetalhamento"]
            .filter(volume => volume.temRessalva !== "Sim");
      if (selected && volumes.length > 0) {
        this.savePedidoEtiquetas(pedidoId);
        var etiquetas = this.pedidoEtiquetas.find(p => p.pedidoId == pedidoId);
        if (etiquetas) {
          etiquetas["pedidoId"] = pedidoId;
          if (etiquetas["volumes"]) {
            volumes
            .forEach(volume => {
             this.savePedidoVolumeDetalhamento(etiquetas, volume, selected, pedidoId);
            });
          }
          else {
            etiquetas["volumes"] = [];
            pedido["pedidoVolumeDetalhamento"]
            .filter(volume => volume.temRessalva !== "Sim")
            .forEach(volume => {
              this.savePedidoVolumeDetalhamento(etiquetas, volume, selected, pedidoId);
            });
          }
        }
      } else {
        //var pedidoVolumeDetalhamento = this.pedidoVolumeDetalhamento;
        pedido["pedidoVolumeDetalhamento"].forEach(volume => {
          this.removeVolumeMemory(volume, pedido);
        });

      }
    }

  }


  saveOnMemoryItemVolume(pedido, volume, selected) {
    if (pedido.flgEmRota === false) {
      var pedidoId = parseInt(pedido["nrt"]);
      // pedido["selected"] = selected;
      if (selected) {
        this.savePedidoEtiquetas(pedidoId);

        var etiquetas = this.pedidoEtiquetas.find(p => p.pedidoId == pedidoId);
        if (etiquetas) {
          etiquetas["pedidoId"] = pedidoId;
          if (etiquetas["volumes"]) {
            this.savePedidoVolumeDetalhamento(etiquetas, volume, selected, pedidoId);
          }

          else {
            etiquetas["volumes"] = [];
            this.savePedidoVolumeDetalhamento(etiquetas, volume, selected, pedidoId);
          }
        }
      } else {
        this.removeVolumeMemory(volume, pedido);

      }
    }

  }


  private removeVolumeMemory(volume: any, pedido: any) {
    this.removePedidoVolumeDetalhamento(volume);
    this.removePedidoEtiquetas(pedido, volume);
  }

  private removePedidoEtiquetas(pedido: any, volume: any) {
    let pedEtiqueta = this.pedidoEtiquetas.find(e => e["pedidoId"] == pedido["nrt"]);
    let volumes = pedEtiqueta["volumes"];
    if (volumes) {
      let volumeRemove = volumes.find(v => v["volumeId"] == volume["volumeId"]);
      if (volumeRemove) {
        let index = volumes.indexOf(volumeRemove);
        volumes.splice(index, 1);
        if(volumes && volumes.length == 0){
          let indexEtiqueta = this.pedidoEtiquetas.indexOf(pedEtiqueta);
          this.pedidoEtiquetas.splice(indexEtiqueta, 1);
        }
      }
    }
  }

  private removePedidoVolumeDetalhamento(volume: any) {
    let volumeRemove = this.pedidoVolumeDetalhamento.find(p => p["volumeId"] == volume["volumeId"]);
    if (volumeRemove) {
      let index = this.pedidoVolumeDetalhamento.indexOf(volumeRemove);
      this.pedidoVolumeDetalhamento.splice(index, 1);
    }
  }

  private savePedidoEtiquetas(pedidoId: number) {
    this.pedidoEtiquetas = [];
    if (!this.pedidoEtiquetas.find(p => p.pedidoId == pedidoId))
      this.pedidoEtiquetas.push({ pedidoId: pedidoId });
  }

  private savePedidoVolumeDetalhamento(etiquetas: any, volume: any, selected: any, pedidoId: number) {
    this.pedidoVolumeDetalhamento = [];
    const notSelected = !this.pedidoVolumeDetalhamento.find(v => v["volumeId"] == volume["volumeId"]);
    if(notSelected){
      etiquetas["volumes"].push({ pedidoEtiquetaId: volume["pedidoEtiquetaId"], volumeId: volume["volumeId"] });
      volume.selected = selected;
      volume.pedidoId = pedidoId;
      this.pedidoVolumeDetalhamento.push(volume);
    }
  }

  saveOnMemoryVolumeMultiple(pedidos, selected) {
    pedidos
    .filter(pedido => pedido.flgEmRota === false && pedido["pedidoVolumeDetalhamento"].length > 0)
      .forEach(pedido => {
          var pedidoId = parseInt(pedido["nrt"]);
          var etiquetas = { pedidoId: pedidoId };
            etiquetas["pedidoId"] = parseInt(pedido["nrt"]);
            etiquetas["volumes"] = [];
            let volumes = pedido["pedidoVolumeDetalhamento"]
            .filter(volume => volume.temRessalva !== "Sim")
            if(volumes.length > 0) {
              volumes.forEach(volume => {
                this.savePedidoVolumeDetalhamento(etiquetas, volume, selected, pedidoId);
              });
              this.pedidoEtiquetas.push(etiquetas);
            }

      });
  }

  selectItem(pedido, volume, selected) {
    this.saveOnMemoryItemVolume(pedido, volume, selected);
    this.updateSelection();
  }



  setTotalItens(pedidos) {
    var total = 0;
    if (this.isRessalvaPorVolume) {
      pedidos.forEach(p => {
        if (!(p.rat && p.rat > 0) && p.flgEmRota === false) {
          //soma total de volumes de todos os pedidos
          total += p["pedidoVolumeDetalhamento"] != undefined ? p["pedidoVolumeDetalhamento"].length : 0;
        }

      });
    } else {
      total = pedidos.length;
    }
    this.total = total;
  }


}
